import FlexibleContent from './FlexibleContent'

export default FlexibleContent
